import { render, staticRenderFns } from "./AtomCustomAvatar.vue?vue&type=template&id=3fab9db3&scoped=true&"
import script from "./AtomCustomAvatar.vue?vue&type=script&lang=js&"
export * from "./AtomCustomAvatar.vue?vue&type=script&lang=js&"
import style0 from "./AtomCustomAvatar.vue?vue&type=style&index=0&id=3fab9db3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fab9db3",
  null
  
)

export default component.exports